export const apiVersionPrefix: string = "/api/v0";

export const locationAutocompleteApiPrefix: string = `${apiVersionPrefix}/autocomplete/location`;
export const calendarApiPrefix: string = `${apiVersionPrefix}/calendar`;
export const tripDetailsApiPrefix: string = `${apiVersionPrefix}/tripDetail`;
export const watchApiPrefix: string = `${apiVersionPrefix}/alert/watch`;
export const tripSummariesApiPrefix: string = `${apiVersionPrefix}/shopSummary`;
export const passengersApiPrefix: string = `${apiVersionPrefix}/passengers`;
export const paymentMethodsApiPrefix: string = `${apiVersionPrefix}/paymentMethods`;
export const rewardsApiPrefix: string = `${apiVersionPrefix}/rewards`;
export const passengerValidationApiPrefix: string = `${apiVersionPrefix}/passengerValidation`;
export const tripPriceApiPrefix: string = `${apiVersionPrefix}/tripPrice`;
export const paymentApiPrefix: string = `${apiVersionPrefix}/payment`;
export const analyticsApiPrefix: string = `${apiVersionPrefix}/tracking`;
export const agentPortalChargeBookingFeeApi: string = `${apiVersionPrefix}/agentPortal/chargeBookingFee`;
export const experimentsApiPrefix: string = `${apiVersionPrefix}/experiments`;

export const analyticsEventApi: string = `${analyticsApiPrefix}/event`;

export const fetchUserInfoPath: string = `${apiVersionPrefix}/userInfo`;

export const customerDetailsApiPath: string = `${apiVersionPrefix}/customer/details`;

export const seatApiPrefix: string = `${apiVersionPrefix}/seats`;
export const seatMapsApiPrefix: string = `${seatApiPrefix}/seatMap`;

export const priceDropApiPrefix: string = `${apiVersionPrefix}/pricedrop`;
export const fetchEligibilityApiPrefix: string = `${priceDropApiPrefix}/eligibility/get`;

export const userApiPrefix = `${apiVersionPrefix}/user`;
export const travelWalletApiPrefix = `${userApiPrefix}/wallet`;

// User preferences
export const userPreferenceApiPrefix: string = `${apiVersionPrefix}/user/preference`;
export const userMetadataPath: string = `${userPreferenceApiPrefix}/metadata`;

export const lodgingLocationAutocompleteApiPrefix: string = `${apiVersionPrefix}/autocomplete/lodging`;
export const hotelAvailabilityApiPrefix: string = `${apiVersionPrefix}/hotels/availability`;
export const flightItinerariesApiPrefix: string = `${apiVersionPrefix}/itinerary/flight`;
export const hotelItinerariesApiPrefix: string = `${apiVersionPrefix}/itinerary/hotel`;

export const potentialCrossSellOffersApiPrefix: string = `${apiVersionPrefix}/crosssell/offers/potential`;
// Customer Preferences
export const userFlightPreferencesPath: string = `${apiVersionPrefix}/user/preference/flight`;

// Corporate Travel
export const fetchPolicies = `${apiVersionPrefix}/policies/details`;

// Engagement data stream
export const engagementDataApiPrefix: string = `${apiVersionPrefix}/engagement`;
export const trackEngagementDataPath: string = `${engagementDataApiPrefix}/event`;
